export default class Accordion {
  constructor(el, isOpen = false) {
    this.el = el;
    this.summary = el.querySelector('.c-accordion__title');
    this.content = el.querySelector('.c-accordion__content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    // CSS変数を取得
    const rootStyle = getComputedStyle(document.documentElement);
    const transitionDuration = rootStyle.getPropertyValue('--transition-duration-base').trim();

    this.transitionDuration = this.parseTransitionDuration(transitionDuration) || 400;
    this.transitionTiming = rootStyle.getPropertyValue('--transition-timing-base').trim() || 'ease-out';

    // クリック時のイベントを設定
    this.summary.addEventListener('click', (e) => this.onClick(e));

    this.el.open = isOpen;
    this.summary.classList.toggle('is-open', this.el.open);
    this.content.classList.toggle('is-open', this.el.open);
  }

  getOffsetHeightWithMargin(el) {
    const style = window.getComputedStyle(el);
    return el.offsetHeight + parseInt(style.marginTop) + parseInt(style.marginBottom);
  }

  // ミリ秒に変換するヘルパー関数
  parseTransitionDuration(value) {
    if (!value) return null;

    const matches = value.match(/^([\d.]+)([ms]+)$/);
    if (!matches) return null;

    const numericValue = parseFloat(matches[1]);
    const unit = matches[2];

    if (unit === 's') {
      return numericValue * 1000; // 秒をミリ秒に変換
    } else if (unit === 'ms') {
      return numericValue; // 既にミリ秒の場合はそのまま返す
    }

    return null;
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';

    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }

    // マウスクリック時に開閉状態を判別するクラスを付与
    this.el.classList.toggle('is-open', this.el.open);
    this.summary.classList.toggle('is-open', this.el.open);
    this.content.classList.toggle('is-open', this.el.open);
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.getOffsetHeightWithMargin(this.el)}px`;
    const endHeight = `${this.getOffsetHeightWithMargin(this.summary)}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: this.transitionDuration,
      easing: this.transitionTiming
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.getOffsetHeightWithMargin(this.el)}px`;
    this.el.open = true;

    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.getOffsetHeightWithMargin(this.el)}px`;
    const endHeight = `${this.getOffsetHeightWithMargin(this.summary) + this.getOffsetHeightWithMargin(this.content)}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: this.transitionDuration,
      easing: this.transitionTiming
    });

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';

    // アニメーション終了時に開閉状態を判別するクラスを更新
    this.el.classList.toggle('is-open', open);
    this.summary.classList.toggle('is-open', this.el.open);
    this.content.classList.toggle('is-open', this.el.open);
  }
}
